module.exports = __webpack_public_path__ + "static/minds_generic-c6fc8d3990be5dd147a164620cb51fb8.png";